import _classCallCheck from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classPrivateFieldInitSpec from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldSet from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet2.js";
import _classPrivateFieldGet from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _time = /*#__PURE__*/new WeakMap();
var _value = /*#__PURE__*/new WeakMap();
var _loopSpan = /*#__PURE__*/new WeakMap();
var _config = /*#__PURE__*/new WeakMap();
var _stop = /*#__PURE__*/new WeakMap();
var _countdate = /*#__PURE__*/new WeakMap();
var _countdown = /*#__PURE__*/new WeakMap();
var _countdateSmart = /*#__PURE__*/new WeakMap();
var _countdateStandard = /*#__PURE__*/new WeakMap();
export var CountdownService = /*#__PURE__*/function () {
  function CountdownService() {
    var _this = this;
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, CountdownService);
    _classPrivateFieldInitSpec(this, _time, 0);
    _classPrivateFieldInitSpec(this, _value, 0);
    _classPrivateFieldInitSpec(this, _loopSpan, void 0);
    _classPrivateFieldInitSpec(this, _config, {
      mode: "standard",
      value: 0,
      format: undefined,
      onStop: function onStop(value) {},
      onChange: function onChange(value) {}
    });
    _classPrivateFieldInitSpec(this, _stop, function () {
      clearTimeout(_classPrivateFieldGet(_loopSpan, _this));
    });
    _classPrivateFieldInitSpec(this, _countdate, function () {
      if (_classPrivateFieldGet(_config, _this).mode === "standard") {
        _classPrivateFieldGet(_countdateStandard, _this).call(_this);
      } else if (_classPrivateFieldGet(_config, _this).mode === "smart") {
        _classPrivateFieldGet(_countdateSmart, _this).call(_this);
      }
    });
    _classPrivateFieldInitSpec(this, _countdown, function () {
      var value = Math.round(_classPrivateFieldGet(_config, _this).value);
      var loop = function loop() {
        _classPrivateFieldGet(_stop, _this).call(_this);
        _classPrivateFieldGet(_config, _this).onChange({
          value: value,
          time: value
        });
        if (value > 0) {
          value -= 1;
          _classPrivateFieldSet(_loopSpan, _this, setTimeout(loop, 1000));
        } else {
          _classPrivateFieldGet(_config, _this).onStop({
            value: value,
            time: value
          });
        }
        _classPrivateFieldSet(_time, _this, value);
        _classPrivateFieldSet(_value, _this, value);
      };
      loop();
    });
    _classPrivateFieldInitSpec(this, _countdateSmart, function () {
      var value = Math.round(_classPrivateFieldGet(_config, _this).value);
      var format = _classPrivateFieldGet(_config, _this).format.toLowerCase();
      var loop = function loop() {
        _classPrivateFieldGet(_stop, _this).call(_this);
        var number = value;
        var time = format,
          d = 0,
          h = 0,
          m = 0,
          s = 0;
        if (time.search("s") !== -1) {
          if (time.search("m") !== -1) {
            s = number % 60;
            number = Math.floor(number / 60);
            if (time.search("h") !== -1) {
              m = number % 60;
              number = Math.floor(number / 60);
              if (time.search("d") !== -1) {
                h = number % 24;
                d = Math.floor(number / 24);
                if (d > 0) {
                  if (time.search("dd") !== -1) {
                    if (d < 10) {
                      d = "0" + d.toString();
                    }
                    time = time.replace(/dd/gi, d);
                  } else {
                    time = time.replace(/d/gi, d);
                  }
                } else {
                  time = time.substr(time.search("h"));
                }
              } else {
                h = number;
              }
              if (h > 0 || d > 0) {
                if (time.search("hh") !== -1) {
                  if (h < 10) {
                    h = "0" + h.toString();
                  }
                  time = time.replace(/hh/gi, h);
                } else {
                  time = time.replace(/h/gi, h);
                }
              } else {
                time = time.substr(time.search("m"));
              }
            } else {
              m = number;
            }
            if (m > 0 || h > 0 || d > 0) {
              if (time.search("mm") !== -1) {
                if (m < 10) {
                  m = "0" + m.toString();
                }
                time = time.replace(/mm/gi, m);
              } else {
                time = time.replace(/m/gi, m);
              }
            } else {
              time = time.substr(time.search("s"));
            }
          } else {
            s = number;
          }
          if (time.search("ss") !== -1) {
            if (s < 10) {
              s = "0" + s.toString();
            }
            time = time.replace(/ss/gi, s);
          } else {
            time = time.replace(/s/gi, s);
          }
        }
        _classPrivateFieldSet(_time, _this, time);
        _classPrivateFieldSet(_value, _this, value);
        _classPrivateFieldGet(_config, _this).onChange({
          value: value,
          time: time
        });
        if (value > 0) {
          value -= 1;
          _classPrivateFieldSet(_loopSpan, _this, setTimeout(loop, 1000));
        } else {
          _classPrivateFieldGet(_config, _this).onStop({
            value: value,
            time: time
          });
        }
      };
      loop();
    });
    _classPrivateFieldInitSpec(this, _countdateStandard, function () {
      var value = Math.round(_classPrivateFieldGet(_config, _this).value);
      var format = _classPrivateFieldGet(_config, _this).format.toLowerCase();
      var loop = function loop() {
        _classPrivateFieldGet(_stop, _this).call(_this);
        var number = value;
        var time = format,
          d = 0,
          h = 0,
          m = 0,
          s = 0;
        if (time.search("s") !== -1) {
          if (time.search("m") !== -1) {
            s = number % 60;
            number = Math.floor(number / 60);
            if (time.search("h") !== -1) {
              m = number % 60;
              number = Math.floor(number / 60);
              if (time.search("d") !== -1) {
                h = number % 24;
                d = Math.floor(number / 24);
                if (time.search("dd") !== -1) {
                  if (d < 10) {
                    d = "0" + d.toString();
                  }
                  time = time.replace(/dd/gi, d);
                } else {
                  time = time.replace(/d/gi, d);
                }
              } else {
                h = number;
              }
              if (time.search("hh") !== -1) {
                if (h < 10) {
                  h = "0" + h.toString();
                }
                time = time.replace(/hh/gi, h);
              } else {
                time = time.replace(/h/gi, h);
              }
            } else {
              m = number;
            }
            if (time.search("mm") !== -1) {
              if (m < 10) {
                m = "0" + m.toString();
              }
              time = time.replace(/mm/gi, m);
            } else {
              time = time.replace(/m/gi, m);
            }
          } else {
            s = number;
          }
          if (time.search("ss") !== -1) {
            if (s < 10) {
              s = "0" + s.toString();
            }
            time = time.replace(/ss/gi, s);
          } else {
            time = time.replace(/s/gi, s);
          }
        }
        _classPrivateFieldSet(_time, _this, time);
        _classPrivateFieldSet(_value, _this, value);
        _classPrivateFieldGet(_config, _this).onChange({
          value: value,
          time: time
        });
        if (value > 0) {
          value -= 1;
          _classPrivateFieldSet(_loopSpan, _this, setTimeout(loop, 1000));
        } else {
          _classPrivateFieldGet(_config, _this).onStop({
            value: value,
            time: time
          });
        }
      };
      loop();
    });
    _classPrivateFieldSet(_config, this, Object.assign(_classPrivateFieldGet(_config, this), config));
    if (_classPrivateFieldGet(_config, this).format) {
      _classPrivateFieldGet(_countdate, this).call(this);
    } else {
      _classPrivateFieldGet(_countdown, this).call(this);
    }
  }
  return _createClass(CountdownService, [{
    key: "getTime",
    value: function getTime() {
      return _classPrivateFieldGet(_time, this);
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return _classPrivateFieldGet(_value, this);
    }
  }]);
}();